import script from "./BlocInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./BlocInformation.vue?vue&type=script&setup=true&lang=js"

import "./BlocInformation.vue?vue&type=style&index=0&id=deaaf658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deaaf658"]])

export default __exports__